var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTowing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 316.639,
    height: 178.344,
    viewBox: "0 0 316.639 178.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "towing",
    transform: "translate(-15.606 -299.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(30.473 299.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(63.885 33.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 33.683,
    height: 142.44,
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(6.248 9.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(5.3 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M227.708,166.945c-.075,0-.137-4.417-.137-9.863s.062-9.864.137-9.864.137,4.416.137,9.864S227.784,166.945,227.708,166.945Z",
    transform: "translate(-227.571 -147.217)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M226.2,162.153a47.972,47.972,0,0,1-5.119.137,47.97,47.97,0,0,1-5.119-.137,47.881,47.881,0,0,1,5.119-.137A47.883,47.883,0,0,1,226.2,162.153Z",
    transform: "translate(-215.959 -162.016)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    transform: "translate(0 13.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M226.215,177.7a48.9,48.9,0,0,1-5.161.137,48.887,48.887,0,0,1-5.161-.137,48.664,48.664,0,0,1,5.161-.137A48.678,48.678,0,0,1,226.215,177.7Z",
    transform: "translate(-215.893 -177.561)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(6.248 35.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(5.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M227.708,223.721c-.075,0-.137-4.417-.137-9.864s.062-9.864.137-9.864.137,4.416.137,9.864S227.784,223.721,227.708,223.721Z",
    transform: "translate(-227.571 -203.993)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M226.2,218.93a47.887,47.887,0,0,1-5.119.137,47.886,47.886,0,0,1-5.119-.137,48.1,48.1,0,0,1,5.119-.137A48.1,48.1,0,0,1,226.2,218.93Z",
    transform: "translate(-215.959 -218.793)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M226.215,234.475a48.681,48.681,0,0,1-5.161.137,48.667,48.667,0,0,1-5.161-.137,48.892,48.892,0,0,1,5.161-.137A48.907,48.907,0,0,1,226.215,234.475Z",
    transform: "translate(-215.893 -234.338)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(6.248 61.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(0.03 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(5.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M227.708,280.5c-.075,0-.137-4.417-.137-9.863s.062-9.865.137-9.865.137,4.416.137,9.865S227.784,280.5,227.708,280.5Z",
    transform: "translate(-227.571 -260.769)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M226.2,275.706a47.892,47.892,0,0,1-5.119.137,47.891,47.891,0,0,1-5.119-.137,48.1,48.1,0,0,1,5.119-.137A48.1,48.1,0,0,1,226.2,275.706Z",
    transform: "translate(-215.959 -275.569)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M226.215,291.251a48.914,48.914,0,0,1-5.161.137,48.9,48.9,0,0,1-5.161-.137,48.647,48.647,0,0,1,5.161-.137A48.661,48.661,0,0,1,226.215,291.251Z",
    transform: "translate(-215.893 -291.114)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    transform: "translate(6.248 87.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(5.3 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M227.708,337.274c-.075,0-.137-4.417-.137-9.863s.062-9.864.137-9.864.137,4.416.137,9.864S227.784,337.274,227.708,337.274Z",
    transform: "translate(-227.571 -317.546)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M226.2,332.482a47.892,47.892,0,0,1-5.119.137,47.891,47.891,0,0,1-5.119-.137,47.876,47.876,0,0,1,5.119-.137A47.877,47.877,0,0,1,226.2,332.482Z",
    transform: "translate(-215.959 -332.345)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(0 13.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M226.215,348.027a48.808,48.808,0,0,1-5.161.137,48.794,48.794,0,0,1-5.161-.137,48.677,48.677,0,0,1,5.161-.137A48.691,48.691,0,0,1,226.215,348.027Z",
    transform: "translate(-215.893 -347.89)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(23.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 24.542,
    height: 142.44,
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(31.056 9.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(5.3 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M282.369,166.945c-.076,0-.137-4.417-.137-9.863s.061-9.864.137-9.864.137,4.416.137,9.864S282.444,166.945,282.369,166.945Z",
    transform: "translate(-282.232 -147.217)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M280.858,162.153a95.985,95.985,0,0,1-10.238,0,95.665,95.665,0,0,1,10.238,0Z",
    transform: "translate(-270.62 -162.016)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(0 13.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M280.875,177.7a97.545,97.545,0,0,1-10.321,0,97.22,97.22,0,0,1,10.321,0Z",
    transform: "translate(-270.554 -177.561)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(31.056 35.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(5.3 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M282.369,224.187c-.076,0-.137-4.417-.137-9.864s.061-9.864.137-9.864.137,4.416.137,9.864S282.444,224.187,282.369,224.187Z",
    transform: "translate(-282.232 -204.459)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M280.858,219.4a95.654,95.654,0,0,1-10.238,0,95.654,95.654,0,0,1,10.238,0Z",
    transform: "translate(-270.62 -219.258)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M280.875,234.941a97.22,97.22,0,0,1-10.321,0,97.545,97.545,0,0,1,10.321,0Z",
    transform: "translate(-270.554 -234.804)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450",
    transform: "translate(31.056 61.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(5.3 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M282.369,281.429c-.076,0-.137-4.417-.137-9.864s.061-9.864.137-9.864.137,4.416.137,9.864S282.444,281.429,282.369,281.429Z",
    transform: "translate(-282.232 -261.701)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M280.858,276.638a95.665,95.665,0,0,1-10.238,0,95.963,95.963,0,0,1,10.238,0Z",
    transform: "translate(-270.62 -276.501)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M280.875,292.183a97.231,97.231,0,0,1-10.321,0,97.513,97.513,0,0,1,10.321,0Z",
    transform: "translate(-270.554 -292.046)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(31.056 87.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(0.03 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(5.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M282.369,338.671c-.076,0-.137-4.417-.137-9.864s.061-9.864.137-9.864.137,4.416.137,9.864S282.444,338.671,282.369,338.671Z",
    transform: "translate(-282.232 -318.943)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M280.858,333.88a95.643,95.643,0,0,1-10.238,0,95.963,95.963,0,0,1,10.238,0Z",
    transform: "translate(-270.62 -333.743)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M280.875,349.425a97.231,97.231,0,0,1-10.321,0,97.513,97.513,0,0,1,10.321,0Z",
    transform: "translate(-270.554 -349.288)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(6.248 113.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(5.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M227.708,394.05c-.075,0-.137-4.417-.137-9.864s.062-9.864.137-9.864.137,4.416.137,9.864S227.784,394.05,227.708,394.05Z",
    transform: "translate(-227.571 -374.322)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M226.2,389.259a47.883,47.883,0,0,1-5.119.137,47.881,47.881,0,0,1-5.119-.137,48.106,48.106,0,0,1,5.119-.137A48.107,48.107,0,0,1,226.2,389.259Z",
    transform: "translate(-215.959 -389.122)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M226.215,404.8a48.671,48.671,0,0,1-5.161.137,48.656,48.656,0,0,1-5.161-.137,48.9,48.9,0,0,1,5.161-.137A48.914,48.914,0,0,1,226.215,404.8Z",
    transform: "translate(-215.893 -404.667)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "translate(31.056 113.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(0.03 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(5.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M282.369,395.913c-.076,0-.137-4.417-.137-9.863s.061-9.865.137-9.865.137,4.416.137,9.865S282.444,395.913,282.369,395.913Z",
    transform: "translate(-282.232 -376.185)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M280.858,391.122a95.985,95.985,0,0,1-10.238,0,95.643,95.643,0,0,1,10.238,0Z",
    transform: "translate(-270.62 -390.985)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M280.875,406.667a97.534,97.534,0,0,1-10.321,0,97.209,97.209,0,0,1,10.321,0Z",
    transform: "translate(-270.554 -406.53)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(211.415 33.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 33.683,
    height: 142.44,
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518",
    transform: "translate(6.247 9.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    transform: "translate(5.301 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M552.758,166.037c-.076,0-.137-4.417-.137-9.863s.061-9.864.137-9.864.137,4.416.137,9.864S552.833,166.037,552.758,166.037Z",
    transform: "translate(-552.621 -146.309)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M551.246,161.246a95.646,95.646,0,0,1-10.237,0,95.955,95.955,0,0,1,10.237,0Z",
    transform: "translate(-541.009 -161.109)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M551.264,176.791a97.227,97.227,0,0,1-10.322,0,97.553,97.553,0,0,1,10.322,0Z",
    transform: "translate(-540.942 -176.654)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534",
    transform: "translate(6.247 35.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    transform: "translate(0.03 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(5.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M552.758,222.813c-.076,0-.137-4.417-.137-9.864s.061-9.864.137-9.864.137,4.416.137,9.864S552.833,222.813,552.758,222.813Z",
    transform: "translate(-552.621 -203.085)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M551.246,218.022a95.635,95.635,0,0,1-10.237,0,95.955,95.955,0,0,1,10.237,0Z",
    transform: "translate(-541.009 -217.885)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M551.264,233.567a97.227,97.227,0,0,1-10.322,0,97.553,97.553,0,0,1,10.322,0Z",
    transform: "translate(-540.942 -233.43)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    transform: "translate(6.247 61.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "translate(5.301 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M552.758,279.59c-.076,0-.137-4.417-.137-9.863s.061-9.864.137-9.864.137,4.416.137,9.864S552.833,279.59,552.758,279.59Z",
    transform: "translate(-552.621 -259.862)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M551.246,274.8a95.678,95.678,0,0,1-10.237,0,95.955,95.955,0,0,1,10.237,0Z",
    transform: "translate(-541.009 -274.661)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "translate(0 13.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M551.264,290.343a97.585,97.585,0,0,1-10.322,0,97.217,97.217,0,0,1,10.322,0Z",
    transform: "translate(-540.942 -290.206)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(6.247 87.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(5.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M552.758,336.366c-.076,0-.137-4.417-.137-9.863s.061-9.864.137-9.864.137,4.416.137,9.864S552.833,336.366,552.758,336.366Z",
    transform: "translate(-552.621 -316.638)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M551.246,331.575a95.657,95.657,0,0,1-10.237,0,95.977,95.977,0,0,1,10.237,0Z",
    transform: "translate(-541.009 -331.438)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M551.264,347.12a97.217,97.217,0,0,1-10.322,0,97.564,97.564,0,0,1,10.322,0Z",
    transform: "translate(-540.942 -346.983)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(23.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 24.542,
    height: 142.44,
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(31.056 9.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(5.301 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M607.419,166.037c-.076,0-.137-4.417-.137-9.863s.061-9.864.137-9.864.137,4.416.137,9.864S607.494,166.037,607.419,166.037Z",
    transform: "translate(-607.282 -146.309)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M605.908,161.246a95.646,95.646,0,0,1-10.237,0,95.955,95.955,0,0,1,10.237,0Z",
    transform: "translate(-595.67 -161.109)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M605.925,176.791a97.227,97.227,0,0,1-10.322,0,97.553,97.553,0,0,1,10.322,0Z",
    transform: "translate(-595.603 -176.654)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(31.056 35.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(5.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M607.419,223.279c-.076,0-.137-4.417-.137-9.864s.061-9.864.137-9.864.137,4.416.137,9.864S607.494,223.279,607.419,223.279Z",
    transform: "translate(-607.282 -203.551)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M605.908,218.488a95.646,95.646,0,0,1-10.237,0,95.966,95.966,0,0,1,10.237,0Z",
    transform: "translate(-595.67 -218.351)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M605.925,234.033a97.238,97.238,0,0,1-10.322,0,97.553,97.553,0,0,1,10.322,0Z",
    transform: "translate(-595.603 -233.896)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(31.056 61.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(5.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M607.419,280.521c-.076,0-.137-4.417-.137-9.864s.061-9.864.137-9.864.137,4.416.137,9.864S607.494,280.521,607.419,280.521Z",
    transform: "translate(-607.282 -260.793)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M605.908,275.73a95.657,95.657,0,0,1-10.237,0,95.934,95.934,0,0,1,10.237,0Z",
    transform: "translate(-595.67 -275.593)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M605.925,291.275a97.217,97.217,0,0,1-10.322,0,97.564,97.564,0,0,1,10.322,0Z",
    transform: "translate(-595.603 -291.138)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(31.056 87.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(0.03 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(5.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M607.419,337.763c-.076,0-.137-4.417-.137-9.863s.061-9.865.137-9.865.137,4.416.137,9.865S607.494,337.763,607.419,337.763Z",
    transform: "translate(-607.282 -318.035)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M605.908,332.972a95.657,95.657,0,0,1-10.237,0,95.934,95.934,0,0,1,10.237,0Z",
    transform: "translate(-595.67 -332.835)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M605.925,348.517a97.542,97.542,0,0,1-10.322,0,97.238,97.238,0,0,1,10.322,0Z",
    transform: "translate(-595.603 -348.38)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649",
    transform: "translate(6.247 113.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(0.03 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(5.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M552.758,393.142c-.076,0-.137-4.417-.137-9.863s.061-9.865.137-9.865.137,4.416.137,9.865S552.833,393.142,552.758,393.142Z",
    transform: "translate(-552.621 -373.414)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M551.246,388.351a95.657,95.657,0,0,1-10.237,0,95.977,95.977,0,0,1,10.237,0Z",
    transform: "translate(-541.009 -388.214)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(0 13.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M551.264,403.9a97.238,97.238,0,0,1-10.322,0,97.52,97.52,0,0,1,10.322,0Z",
    transform: "translate(-540.942 -403.759)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(31.056 113.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 10.238,
    height: 19.728,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(5.301 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M607.419,395.006c-.076,0-.137-4.417-.137-9.863s.061-9.864.137-9.864.137,4.416.137,9.864S607.494,395.006,607.419,395.006Z",
    transform: "translate(-607.282 -375.278)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(0.03 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M605.908,390.214a95.657,95.657,0,0,1-10.237,0,95.657,95.657,0,0,1,10.237,0Z",
    transform: "translate(-595.67 -390.077)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(0 13.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M605.925,405.759a97.564,97.564,0,0,1-10.322,0,97.238,97.238,0,0,1,10.322,0Z",
    transform: "translate(-595.603 -405.622)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    transform: "translate(109.22 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 41.617,
    height: 175.994,
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(7.719 12.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(0.038 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 12.649,
    height: 24.375,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(6.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M333.619,102.475c-.093,0-.169-5.457-.169-12.187s.076-12.188.169-12.188.169,5.456.169,12.188S333.713,102.475,333.619,102.475Z",
    transform: "translate(-333.45 -78.1)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(0.038 8.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M331.752,96.555a118.227,118.227,0,0,1-12.649,0,118.536,118.536,0,0,1,12.649,0Z",
    transform: "translate(-319.103 -96.386)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(0 17.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M331.773,115.762a120.5,120.5,0,0,1-12.753,0,120.174,120.174,0,0,1,12.753,0Z",
    transform: "translate(-319.02 -115.593)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(7.719 44.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(0.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 12.649,
    height: 24.375,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(6.549 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M333.619,172.626c-.093,0-.169-5.457-.169-12.187s.076-12.188.169-12.188.169,5.456.169,12.188S333.713,172.626,333.619,172.626Z",
    transform: "translate(-333.45 -148.251)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(0.038 8.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M331.752,166.706a118.227,118.227,0,0,1-12.649,0,118.536,118.536,0,0,1,12.649,0Z",
    transform: "translate(-319.103 -166.537)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(0 17.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M331.773,185.913a120.184,120.184,0,0,1-12.753,0,120.488,120.488,0,0,1,12.753,0Z",
    transform: "translate(-319.02 -185.744)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(7.719 76.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(0.038 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 12.649,
    height: 24.375,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(6.549 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M333.619,242.776c-.093,0-.169-5.457-.169-12.187s.076-12.189.169-12.189.169,5.456.169,12.189S333.713,242.776,333.619,242.776Z",
    transform: "translate(-333.45 -218.401)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(0.038 8.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M331.752,236.857a118.227,118.227,0,0,1-12.649,0,118.536,118.536,0,0,1,12.649,0Z",
    transform: "translate(-319.103 -236.688)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(0 17.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M331.773,256.063a120.163,120.163,0,0,1-12.753,0,120.174,120.174,0,0,1,12.753,0Z",
    transform: "translate(-319.02 -255.894)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(7.719 107.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(0.038 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 12.649,
    height: 24.375,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724",
    transform: "translate(6.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M333.619,312.927c-.093,0-.169-5.457-.169-12.187s.076-12.189.169-12.189.169,5.456.169,12.189S333.713,312.927,333.619,312.927Z",
    transform: "translate(-333.45 -288.552)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(0.038 8.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M331.752,307.007a118.206,118.206,0,0,1-12.649,0,118.227,118.227,0,0,1,12.649,0Z",
    transform: "translate(-319.103 -306.838)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    transform: "translate(0 17.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M331.773,326.214a120.163,120.163,0,0,1-12.753,0,120.206,120.206,0,0,1,12.753,0Z",
    transform: "translate(-319.02 -326.045)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736",
    transform: "translate(28.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 30.323,
    height: 175.994,
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(38.372 12.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739",
    transform: "translate(0.038 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 12.649,
    height: 24.375,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743",
    transform: "translate(6.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M401.156,102.475c-.094,0-.169-5.457-.169-12.187s.076-12.188.169-12.188.169,5.456.169,12.188S401.249,102.475,401.156,102.475Z",
    transform: "translate(-400.987 -78.1)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747",
    transform: "translate(0.038 8.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M399.289,96.555a118.226,118.226,0,0,1-12.649,0,118.536,118.536,0,0,1,12.649,0Z",
    transform: "translate(-386.64 -96.386)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751",
    transform: "translate(0 17.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M399.31,115.762a120.5,120.5,0,0,1-12.753,0,120.174,120.174,0,0,1,12.753,0Z",
    transform: "translate(-386.557 -115.593)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    transform: "translate(38.372 44.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755",
    transform: "translate(0.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 12.649,
    height: 24.375,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759",
    transform: "translate(6.549 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M401.156,173.2c-.094,0-.169-5.457-.169-12.187s.076-12.188.169-12.188.169,5.455.169,12.188S401.249,173.2,401.156,173.2Z",
    transform: "translate(-400.987 -148.827)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763",
    transform: "translate(0.038 8.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M399.289,167.281a118.216,118.216,0,0,1-12.649,0,118.216,118.216,0,0,1,12.649,0Z",
    transform: "translate(-386.64 -167.112)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767",
    transform: "translate(0 17.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M399.31,186.488a119.839,119.839,0,0,1-12.753,0,120.51,120.51,0,0,1,12.753,0Z",
    transform: "translate(-386.557 -186.319)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784",
    transform: "translate(38.372 76.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    transform: "translate(0.038 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 12.649,
    height: 24.375,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775",
    transform: "translate(6.549 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M401.156,243.928c-.094,0-.169-5.457-.169-12.187s.076-12.188.169-12.188.169,5.456.169,12.188S401.249,243.928,401.156,243.928Z",
    transform: "translate(-400.987 -219.553)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    transform: "translate(0.038 8.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M399.289,238.008a118.216,118.216,0,0,1-12.649,0,118.536,118.536,0,0,1,12.649,0Z",
    transform: "translate(-386.64 -237.839)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783",
    transform: "translate(0 17.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M399.31,257.215a120.184,120.184,0,0,1-12.753,0,120.51,120.51,0,0,1,12.753,0Z",
    transform: "translate(-386.557 -257.046)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800",
    transform: "translate(38.372 108.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    transform: "translate(0.038 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 12.649,
    height: 24.375,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791",
    transform: "translate(6.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M401.156,314.654c-.094,0-.169-5.457-.169-12.187s.076-12.188.169-12.188.169,5.456.169,12.188S401.249,314.654,401.156,314.654Z",
    transform: "translate(-400.987 -290.279)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(0.038 8.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M399.289,308.734a118.525,118.525,0,0,1-12.649,0,118.226,118.226,0,0,1,12.649,0Z",
    transform: "translate(-386.64 -308.565)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    transform: "translate(0 17.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M399.31,327.941a120.184,120.184,0,0,1-12.753,0,120.51,120.51,0,0,1,12.753,0Z",
    transform: "translate(-386.557 -327.772)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    "data-name": "Group 816",
    transform: "translate(7.719 139.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803",
    transform: "translate(0.038 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_801",
    "data-name": "Group 801"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 12.649,
    height: 24.375,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807",
    transform: "translate(6.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M333.619,383.078c-.093,0-.169-5.457-.169-12.187s.076-12.189.169-12.189.169,5.456.169,12.189S333.713,383.078,333.619,383.078Z",
    transform: "translate(-333.45 -358.703)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_811",
    "data-name": "Group 811",
    transform: "translate(0.038 8.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M331.752,377.158a118.227,118.227,0,0,1-12.649,0,118.227,118.227,0,0,1,12.649,0Z",
    transform: "translate(-319.103 -376.989)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815",
    transform: "translate(0 17.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M331.773,396.365a120.488,120.488,0,0,1-12.753,0,120.184,120.184,0,0,1,12.753,0Z",
    transform: "translate(-319.02 -396.196)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832",
    transform: "translate(38.372 140.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    "data-name": "Group 819",
    transform: "translate(0.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 12.649,
    height: 24.375,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    "data-name": "Group 823",
    transform: "translate(6.549 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M401.156,385.381c-.094,0-.169-5.457-.169-12.187s.076-12.188.169-12.188.169,5.456.169,12.188S401.249,385.381,401.156,385.381Z",
    transform: "translate(-400.987 -361.006)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827",
    transform: "translate(0.038 8.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M399.289,379.46a118.2,118.2,0,0,1-12.649,0,118.2,118.2,0,0,1,12.649,0Z",
    transform: "translate(-386.64 -379.291)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(0 17.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M399.31,398.667a120.163,120.163,0,0,1-12.753,0,120.163,120.163,0,0,1,12.753,0Z",
    transform: "translate(-386.557 -398.498)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835",
    transform: "translate(196.998 7.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M525.711,74.58c.232-1.683-2.143-3.067-3.928-3.211a10.1,10.1,0,0,1-2.541-.22c-1.747-.609-2.445-2.865-4.149-3.584a4.877,4.877,0,0,0-3.977.563,10.379,10.379,0,0,1-3.836,1.492c-1.2.077-2.5-.368-3.555.218-.782.437-1.193,1.338-1.914,1.871a4.565,4.565,0,0,1-2.5.679,7.042,7.042,0,0,0-2.579.421,2.039,2.039,0,0,0-1.292,2.07Z",
    transform: "translate(-495.413 -67.332)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837",
    transform: "translate(0 20.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M91.669,103.887c.232-1.682-2.143-3.067-3.928-3.211a10.1,10.1,0,0,1-2.541-.22c-1.747-.609-2.445-2.865-4.149-3.584a4.877,4.877,0,0,0-3.977.563,10.387,10.387,0,0,1-3.836,1.492c-1.2.077-2.5-.369-3.555.218-.782.437-1.193,1.338-1.914,1.871a4.561,4.561,0,0,1-2.5.678,7.052,7.052,0,0,0-2.579.422,2.039,2.039,0,0,0-1.292,2.07Z",
    transform: "translate(-61.371 -96.64)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839",
    transform: "translate(32.15 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M179.228,62.169c.359-2.612-3.326-4.76-6.1-4.983a15.67,15.67,0,0,1-3.944-.34c-2.711-.945-3.794-4.447-6.439-5.563-1.977-.834-4.255-.092-6.172.873s-3.812,2.179-5.954,2.317c-1.863.119-3.886-.572-5.517.338-1.215.679-1.851,2.078-2.971,2.9a7.085,7.085,0,0,1-3.883,1.053,10.942,10.942,0,0,0-4,.654,3.165,3.165,0,0,0-2,3.212Z",
    transform: "translate(-132.206 -50.92)",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(22.448 475.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M344.432,438.727c0,.065-67.329.118-150.364.118-83.064,0-150.379-.053-150.379-.118s67.315-.118,150.379-.118C277.1,438.609,344.432,438.662,344.432,438.727Z",
    transform: "translate(-43.689 -438.609)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Car",
    transform: "translate(136.972 340.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867",
    transform: "translate(10.796 32.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 157.474,
    height: 21.287,
    transform: "translate(157.467 22.776) rotate(-179.458)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869",
    transform: "translate(10.796 32.695)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 157.474,
    height: 21.287,
    transform: "translate(157.467 22.776) rotate(-179.458)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    transform: "translate(0.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M300.953,171.5a13.054,13.054,0,0,1,10.812-8.372l35.391-3.825,12.991-9.086a52.917,52.917,0,0,1,30.832-9.553l69.051.654h0l14.84.14a1.449,1.449,0,0,1,.544,2.787l-6.074,2.531a10.828,10.828,0,0,1,.6,1.192l3.342,7.95a15.415,15.415,0,0,1,1.2,6.122,3.458,3.458,0,0,1,3.426,3.491l-.13,13.789,3.569,1.635a4.783,4.783,0,0,1,2.791,4.394l-.034,3.576a5.842,5.842,0,0,1-4.75,5.684l-19,3.614.016-1.714a18.31,18.31,0,0,0-18.136-18.482h0a18.31,18.31,0,0,0-18.482,18.135l-.016,1.714-76.2-.721.016-1.714a18.31,18.31,0,0,0-18.136-18.482h0A18.309,18.309,0,0,0,310.928,195.1l-.016,1.714-9.356-.089a4.574,4.574,0,0,1-4.53-4.617l.1-10.459Z",
    transform: "translate(-297.027 -140.663)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873",
    transform: "translate(168.714 6.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M672.4,155.326l3.342,7.95a15.42,15.42,0,0,1,1.2,6.122l-4.718-.045-4.484-13.528,4.058-1.691A10.832,10.832,0,0,1,672.4,155.326Z",
    transform: "translate(-667.741 -154.134)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875",
    transform: "translate(0.546 28.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_874",
    "data-name": "Group 874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M301.059,205.941a13.045,13.045,0,0,1,1.092-2.217l5.013.047-4.635,10.484-5.308,3,.011-1.167Z",
    transform: "translate(-297.221 -203.724)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877",
    transform: "translate(0.546 28.621)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M301.059,205.941a13.045,13.045,0,0,1,1.092-2.217l5.013.047-4.635,10.484-5.308,3,.011-1.167Z",
    transform: "translate(-297.221 -203.724)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879",
    transform: "translate(168.663 24.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M679.858,204.091l-2.6-.025a7.284,7.284,0,0,1-4.14-1.339l-4.3-3.04a2.829,2.829,0,0,1-1.194-2.335h0a2.828,2.828,0,0,1,2.855-2.8l9.452.089a.415.415,0,0,1,.411.418l-.071,8.621A.415.415,0,0,1,679.858,204.091Z",
    transform: "translate(-667.63 -194.551)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881",
    transform: "translate(0 28.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M296.295,216.121l1.516-.856-.92-.009a.546.546,0,1,1,.01-1.092l2.812.027.953-.538-3.209-.03a.546.546,0,1,1,.01-1.092l4.261.04.241-.545-3.861-.037a.546.546,0,1,1,.01-1.092l4.331.041.241-.545-4.03-.038a.546.546,0,1,1,.01-1.092l4.5.043.241-.545-4.108-.039a.546.546,0,1,1,.01-1.092l4.578.043.241-.545-4.188-.04a.546.546,0,0,1,.01-1.092l4.658.044.241-.545-4.311-.041a.546.546,0,1,1,.01-1.092l4.782.045.334-.754-4.182-.04a.546.546,0,1,1,.01-1.092l5.012.047a.546.546,0,0,1,.494.767l-1.534,3.47h0l-.721,1.631v0l-.721,1.631h0l-.721,1.631v0l-.721,1.631h0l-.213.483a.55.55,0,0,1-.231.255l-5.307,3a.546.546,0,0,1-.537-.951Z",
    transform: "translate(-296.017 -202.521)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883",
    transform: "translate(0 28.075)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M296.295,216.121l1.516-.856-.92-.009a.546.546,0,1,1,.01-1.092l2.812.027.953-.538-3.209-.03a.546.546,0,1,1,.01-1.092l4.261.04.241-.545-3.861-.037a.546.546,0,1,1,.01-1.092l4.331.041.241-.545-4.03-.038a.546.546,0,1,1,.01-1.092l4.5.043.241-.545-4.108-.039a.546.546,0,1,1,.01-1.092l4.578.043.241-.545-4.188-.04a.546.546,0,0,1,.01-1.092l4.658.044.241-.545-4.311-.041a.546.546,0,1,1,.01-1.092l4.782.045.334-.754-4.182-.04a.546.546,0,1,1,.01-1.092l5.012.047a.546.546,0,0,1,.494.767l-1.534,3.47h0l-.721,1.631v0l-.721,1.631h0l-.721,1.631v0l-.721,1.631h0l-.213.483a.55.55,0,0,1-.231.255l-5.307,3a.546.546,0,0,1-.537-.951Z",
    transform: "translate(-296.017 -202.521)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924",
    transform: "translate(127.956 39.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 15.957,
    cy: 15.957,
    rx: 15.957,
    ry: 15.957,
    transform: "matrix(0.997, -0.075, 0.075, 0.997, 0, 2.408)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899",
    transform: "translate(1.159 16.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M612.4,264.728c0,.014,0,.027,0,.041a15.958,15.958,0,0,1-31.915.158c0-.014,0-.027,0-.041Z",
    transform: "translate(-580.493 -264.728)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(5.913 5.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M613.374,251.456a11.2,11.2,0,1,1-11.258-11.147A11.2,11.2,0,0,1,613.374,251.456Z",
    transform: "translate(-590.968 -240.309)",
    fill: "#fafafa"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(5.913 5.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M602.115,240.309a11.2,11.2,0,0,1,11.258,11.147l-22.406.111A11.2,11.2,0,0,1,602.115,240.309Z",
    transform: "translate(-590.968 -240.309)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923",
    transform: "translate(10.291 10.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M614.264,256.747a6.824,6.824,0,1,1-6.858-6.79A6.825,6.825,0,0,1,614.264,256.747Z",
    transform: "translate(-600.615 -249.957)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(16.629 39.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M364.571,243.367a15.957,15.957,0,1,1-16.036-15.878A15.957,15.957,0,0,1,364.571,243.367Z",
    transform: "translate(-332.657 -227.49)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(0 15.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M364.569,262.382c0,.014,0,.028,0,.041a15.957,15.957,0,0,1-31.914.158c0-.014,0-.027,0-.041Z",
    transform: "translate(-332.657 -262.382)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(4.754 4.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M365.537,249.111a11.2,11.2,0,1,1-11.258-11.147A11.2,11.2,0,0,1,365.537,249.111Z",
    transform: "translate(-343.132 -237.964)",
    fill: "#fafafa"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956",
    transform: "translate(4.754 4.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M354.279,237.964a11.2,11.2,0,0,1,11.258,11.147l-22.406.111A11.2,11.2,0,0,1,354.279,237.964Z",
    transform: "translate(-343.132 -237.964)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(9.133 9.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M366.428,254.4a6.824,6.824,0,1,1-6.858-6.79A6.825,6.825,0,0,1,366.428,254.4Z",
    transform: "translate(-352.779 -247.612)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(50.588 3.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M407.476,163.219l12.991-9.086a52.9,52.9,0,0,1,12.088-6.3l4.254.04-25.977,16.912Z",
    transform: "translate(-407.476 -147.831)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(6.15 24.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M315.84,197.719l-6.272-.059a15.278,15.278,0,0,1,3.257-3.135C314.263,194.078,316,195.891,315.84,197.719Z",
    transform: "translate(-309.568 -194.456)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    transform: "translate(57.306 2.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M505.287,165.42l-83.008-.786,23.853-16.13a10.13,10.13,0,0,1,6.008-1.9l51.46.487s18.49-.279,22.495,5.337Z",
    transform: "translate(-422.279 -146.599)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(60.668 3.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M508.622,166.684l-2.929-17.352,9.656.092a31.183,31.183,0,0,1,10.836,2.172l2.9,1.312a2.772,2.772,0,0,1,1.1,4.326l-3.432,4.178a14.533,14.533,0,0,1-10.523,5.315c-.3.015-.6.024-.905.021Zm-38.282-.363L470.5,149l28.442.269,2.922,17.352Zm-40.655-.384,21.469-15.73a6.991,6.991,0,0,1,4.2-1.352l9.834.093-3.492,17.291Z",
    transform: "translate(-429.685 -148.855)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(95.611 21.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M506.842,218.712a.347.347,0,0,0,.007-.082c0-.062,0-.142.006-.241,0-.222.005-.531.01-.925,0-.814.005-1.974.009-3.4-.007-2.883-.016-6.848-.026-11.227-.011-2.192-.022-4.28-.032-6.181-.006-.949-.013-1.852-.018-2.7a14.73,14.73,0,0,1,.1-2.337,16.374,16.374,0,0,1,.8-3.291c.134-.378.249-.668.33-.863l.093-.222a.409.409,0,0,0,.029-.077.3.3,0,0,0-.042.071c-.025.048-.06.121-.106.216-.089.192-.213.479-.356.855a15.63,15.63,0,0,0-.85,3.3,14.576,14.576,0,0,0-.121,2.351c0,.846,0,1.748,0,2.7.006,1.9.013,3.989.02,6.181.027,4.38.051,8.344.069,11.227.015,1.429.028,2.588.037,3.4.008.393.013.7.018.925,0,.1.006.178.008.241A.336.336,0,0,0,506.842,218.712Z",
    transform: "translate(-506.674 -187.165)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980",
    transform: "translate(56.675 22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M424.253,189.136a.3.3,0,0,0-.066.044l-.187.143-.137.107-.143.152a3.177,3.177,0,0,0-.339.4,10.694,10.694,0,0,0-1.469,2.961c-.229.661-.446,1.4-.639,2.2-.1.4-.186.816-.268,1.247a6.185,6.185,0,0,0-.113,1.352c-.015,1.849.02,3.877.052,6.008.071,4.262.164,8.12.239,10.911.041,1.388.074,2.514.1,3.306.015.382.026.683.035.9l.013.234a.348.348,0,0,0,.009.079.3.3,0,0,0,.005-.08l0-.234c0-.216,0-.517-.008-.9-.012-.792-.03-1.919-.052-3.307-.05-2.8-.12-6.655-.2-10.912-.033-2.13-.071-4.16-.064-6a6.071,6.071,0,0,1,.106-1.331c.079-.429.163-.844.259-1.242.187-.8.4-1.532.62-2.192a11.029,11.029,0,0,1,1.417-2.961A5.2,5.2,0,0,1,424.253,189.136Z",
    transform: "translate(-420.887 -189.136)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(57.301 15.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984",
    transform: "translate(0.005 0.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M422.277,181.323h0a2.851,2.851,0,0,1,1.478-2.472l3.757-2.064a7.123,7.123,0,0,1,3.5-.88h0a7.12,7.12,0,0,1,2.215.375,4.052,4.052,0,0,1,2.69,3.746h0a4.118,4.118,0,0,1-4.156,4.236L425.1,184.2A2.851,2.851,0,0,1,422.277,181.323Z",
    transform: "translate(-422.277 -175.906)",
    fill: "#ff725e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M422.271,181.226c.01,0,.01.126.04.361a2.839,2.839,0,0,0,1.454,2.118,2.823,2.823,0,0,0,.959.312,11.243,11.243,0,0,0,1.149.033l5.7.035a4.339,4.339,0,0,0,1.589-.245,4.056,4.056,0,0,0,2.383-2.318,4.133,4.133,0,0,0,.266-1.76,4.041,4.041,0,0,0-1.654-3,4.3,4.3,0,0,0-1.539-.665,7.057,7.057,0,0,0-4.543.393c-.432.187-.827.427-1.22.635l-1.119.608-1.926,1.043a2.848,2.848,0,0,0-1.156,1.118,2.9,2.9,0,0,0-.34.972c-.037.235-.035.361-.045.361a1.8,1.8,0,0,1,.01-.366,2.779,2.779,0,0,1,.316-1,2.893,2.893,0,0,1,1.168-1.171l1.913-1.066,1.114-.618c.389-.209.783-.453,1.225-.649a7.174,7.174,0,0,1,4.641-.422,4.453,4.453,0,0,1,1.6.688,4.2,4.2,0,0,1,1.728,3.126,4.29,4.29,0,0,1-.278,1.835A4.217,4.217,0,0,1,433.219,184a4.5,4.5,0,0,1-1.647.249l-5.7-.073a10.963,10.963,0,0,1-1.163-.046,2.919,2.919,0,0,1-.99-.336,2.953,2.953,0,0,1-1.148-1.192,2.769,2.769,0,0,1-.294-1.007A2.208,2.208,0,0,1,422.271,181.226Z",
    transform: "translate(-422.266 -175.73)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(0.383 0.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M433.09,178.288c-.013.01-.1-.132-.318-.313a2.207,2.207,0,0,0-1.1-.455,4.8,4.8,0,0,0-1.779.175,13.559,13.559,0,0,0-2.1.694,13.753,13.753,0,0,0-3.434,2.09c-.8.659-1.222,1.145-1.246,1.122a2.255,2.255,0,0,1,.285-.352,11.076,11.076,0,0,1,.882-.863,12.825,12.825,0,0,1,5.582-2.846,4.726,4.726,0,0,1,1.833-.141,2.159,2.159,0,0,1,1.123.526,1.468,1.468,0,0,1,.22.258C433.077,178.248,433.095,178.285,433.09,178.288Z",
    transform: "translate(-423.111 -177.358)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(121.718 32.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M564.305,236.141s0-.067,0-.2-.015-.326-.026-.577-.038-.567-.036-.938.022-.8.035-1.28.1-1.012.151-1.6c.029-.292.1-.59.149-.9s.1-.64.186-.972a24.546,24.546,0,0,1,1.47-4.4,23.836,23.836,0,0,1,2.917-4.8,22.732,22.732,0,0,1,4.638-4.458,21.656,21.656,0,0,1,6.37-3.137,25.206,25.206,0,0,1,7.554-1.069,26.146,26.146,0,0,1,7.529,1.261,23.622,23.622,0,0,1,6.352,3.191,25.9,25.9,0,0,1,4.757,4.344,28.219,28.219,0,0,1,3.2,4.619,30.756,30.756,0,0,1,1.889,4.241c.118.321.2.64.3.943s.2.592.264.878c.138.569.283,1.086.379,1.558l.239,1.258c.062.365.093.679.129.93s.06.438.078.572.032.194.032.194,0-.066-.017-.2l-.064-.574c-.032-.252-.058-.566-.116-.933s-.141-.788-.227-1.263-.234-.992-.368-1.564c-.067-.286-.17-.576-.259-.882s-.182-.624-.3-.947a30.374,30.374,0,0,0-1.876-4.264,28.123,28.123,0,0,0-3.2-4.648,25.906,25.906,0,0,0-4.771-4.375,23.7,23.7,0,0,0-6.385-3.217,26.215,26.215,0,0,0-7.571-1.272,25.306,25.306,0,0,0-7.6,1.078,21.741,21.741,0,0,0-6.405,3.164,22.8,22.8,0,0,0-4.655,4.493,23.8,23.8,0,0,0-2.916,4.829,24.37,24.37,0,0,0-1.456,4.423c-.083.333-.121.664-.181.977s-.117.615-.144.908c-.05.585-.12,1.119-.138,1.6s-.015.911-.022,1.284.038.685.05.939.03.442.039.576S564.305,236.141,564.305,236.141Z",
    transform: "translate(-564.197 -211.671)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(137.355 20.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M599.67,199.084a.463.463,0,0,0,.082-.108l.21-.326c.179-.286.432-.7.73-1.227a20.725,20.725,0,0,0,.974-1.884,3.2,3.2,0,0,0,.2-.594.783.783,0,0,0-.014-.338c-.025-.107-.058-.209-.088-.315-.133-.416-.289-.838-.456-1.266-.671-1.714-1.342-3.238-1.829-4.339-.246-.55-.448-.994-.592-1.3l-.169-.35a.068.068,0,1,0-.026.012l.144.36.549,1.316c.464,1.111,1.12,2.641,1.789,4.351.167.427.323.847.456,1.256a1.317,1.317,0,0,1,.1.59,3.165,3.165,0,0,1-.187.564c-.312.726-.656,1.357-.939,1.887l-.689,1.248-.187.34A.513.513,0,0,0,599.67,199.084Z",
    transform: "translate(-598.648 -186.92)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(161.414 38.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M651.658,225.931c0,.04,4.467.094,9.975.122s9.976.017,9.977-.023-4.466-.094-9.976-.121S651.658,225.892,651.658,225.931Z",
    transform: "translate(-651.658 -225.894)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(57.124 52.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M421.877,255.3c0,.04,14.489.209,32.359.377s32.363.272,32.363.232-14.486-.209-32.361-.377S421.877,255.265,421.877,255.3Z",
    transform: "translate(-421.877 -255.296)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(0.462 51.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M297.035,254.467c0,.04,2.219.093,4.955.119s4.957.015,4.957-.025-2.218-.093-4.956-.119S297.035,254.427,297.035,254.467Z",
    transform: "translate(-297.035 -254.427)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(12.965 20.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M324.582,190.752a.57.57,0,0,0,.106,0l.311-.018,1.2-.085c1.038-.075,2.538-.2,4.391-.366,3.705-.333,8.818-.864,14.448-1.6s10.71-1.53,14.377-2.157c1.834-.313,3.316-.578,4.338-.771l1.176-.224.305-.062a.583.583,0,0,0,.1-.026.591.591,0,0,0-.106.011l-.308.048-1.181.2-4.344.726c-3.67.6-8.75,1.38-14.379,2.115s-10.736,1.279-14.438,1.638l-4.386.411L325,190.7l-.31.033A.612.612,0,0,0,324.582,190.752Z",
    transform: "translate(-324.582 -185.445)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(83.497 24.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(0 0.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M481.559,198.57c0-.008-.078-.008-.224-.035a1.558,1.558,0,0,1-.59-.241,1.517,1.517,0,0,1-.6-.79,1.683,1.683,0,0,1-.071-.621,1.519,1.519,0,0,1,.181-.668,1.494,1.494,0,0,1,1.305-.778l1.9.024,4.354.047a1.478,1.478,0,0,1,1.451,1.323,1.649,1.649,0,0,1-.19.994,1.492,1.492,0,0,1-.727.634,2.27,2.27,0,0,1-.939.105l-.922,0-1.656-.007h-2.4l-.652.007a1.363,1.363,0,0,0-.227.013,1.309,1.309,0,0,0,.227.017l.652.02,2.4.046,1.656.025.923.012c.16,0,.315.01.487,0a1.6,1.6,0,0,0,1.3-.8,1.789,1.789,0,0,0,.211-1.078,1.619,1.619,0,0,0-1.592-1.455l-4.355-.035-1.9-.01a1.592,1.592,0,0,0-1.579,1.566,1.749,1.749,0,0,0,.087.649,1.56,1.56,0,0,0,.641.812,1.491,1.491,0,0,0,.617.223A.927.927,0,0,0,481.559,198.57Z",
    transform: "translate(-479.984 -195.314)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(2.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M484.705,194.467a41.617,41.617,0,0,0,4.938.047,41.617,41.617,0,0,0-4.938-.047Z",
    transform: "translate(-484.705 -194.414)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036",
    transform: "translate(124.525 25.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(0 0.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M571.957,199.983c0-.008-.078-.008-.224-.035a1.553,1.553,0,0,1-.59-.241,1.515,1.515,0,0,1-.6-.79,1.682,1.682,0,0,1-.071-.621,1.527,1.527,0,0,1,.181-.669,1.493,1.493,0,0,1,1.305-.778l1.9.024,4.355.047a1.476,1.476,0,0,1,1.451,1.323,1.648,1.648,0,0,1-.19.993,1.492,1.492,0,0,1-.727.634,2.262,2.262,0,0,1-.938.105l-.923,0-1.656-.006h-2.4l-.652.008a1.346,1.346,0,0,0-.228.012,1.277,1.277,0,0,0,.227.017l.652.02,2.4.046,1.656.025.923.013c.16,0,.315.01.487,0a1.6,1.6,0,0,0,1.3-.8,1.8,1.8,0,0,0,.211-1.078,1.621,1.621,0,0,0-1.593-1.455l-4.355-.035-1.9-.01a1.6,1.6,0,0,0-1.4.851,1.62,1.62,0,0,0-.183.715,1.752,1.752,0,0,0,.087.649,1.559,1.559,0,0,0,.642.812,1.483,1.483,0,0,0,.617.223A.9.9,0,0,0,571.957,199.983Z",
    transform: "translate(-570.382 -196.727)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035",
    transform: "translate(2.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M575.1,195.881a41.363,41.363,0,0,0,4.938.047,41.612,41.612,0,0,0-4.938-.047Z",
    transform: "translate(-575.103 -195.827)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(10.069 31.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M318.219,235.012s0-.067.008-.2,0-.326.009-.576,0-.567.018-.937.063-.8.1-1.275.143-1.005.223-1.585c.04-.29.121-.585.184-.9s.128-.635.221-.963a26.545,26.545,0,0,1,1.584-4.354,25.161,25.161,0,0,1,2.977-4.752,23.537,23.537,0,0,1,4.643-4.442,21.936,21.936,0,0,1,6.341-3.174,24.342,24.342,0,0,1,15.048.141,21.947,21.947,0,0,1,6.281,3.293,23.553,23.553,0,0,1,4.559,4.53,25.185,25.185,0,0,1,2.888,4.808,26.625,26.625,0,0,1,1.5,4.383c.087.33.136.657.2.967s.132.609.167.9c.069.581.156,1.11.192,1.589s.055.906.077,1.276,0,.684,0,.937,0,.442,0,.577,0,.2,0,.2.006-.066.01-.2.01-.326.016-.577.023-.568.014-.939l-.064-1.279c-.033-.481-.115-1.012-.181-1.594-.033-.292-.107-.59-.162-.9s-.112-.64-.2-.972a26.43,26.43,0,0,0-1.487-4.406,25.156,25.156,0,0,0-2.885-4.839,23.594,23.594,0,0,0-4.575-4.564,22.025,22.025,0,0,0-6.316-3.321,24.425,24.425,0,0,0-15.136-.142,22.018,22.018,0,0,0-6.376,3.2,23.594,23.594,0,0,0-4.659,4.476,25.137,25.137,0,0,0-2.976,4.783,26.4,26.4,0,0,0-1.57,4.377c-.092.33-.145.658-.216.968s-.139.609-.178.9c-.076.582-.169,1.111-.211,1.591s-.063.907-.088,1.278,0,.685,0,.939,0,.442.006.577S318.219,235.012,318.219,235.012Z",
    transform: "translate(-318.202 -210.594)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "translate(131.732 2.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M586.259,146.6a.864.864,0,0,0,.124.008l.366.009,1.406.021,5.172.049,17.062.107,9.394.041c2.887,0,5.489.049,7.673-.056a38.048,38.048,0,0,0,5.144-.541c.6-.11,1.065-.21,1.377-.288l.355-.089a.847.847,0,0,0,.12-.035s-.042,0-.123.021l-.358.074c-.314.069-.779.16-1.38.261a40.178,40.178,0,0,1-5.139.494c-2.18.093-4.78.038-7.667.025l-9.395-.053-17.062-.064-5.172,0-1.407.006-.366.005C586.3,146.592,586.259,146.6,586.259,146.6Z",
    transform: "translate(-586.259 -145.821)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045",
    transform: "translate(111.972 10.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M542.724,163.32c-.019.035,2.989,1.684,6.718,3.683s6.768,3.591,6.787,3.555-2.989-1.684-6.719-3.683S542.743,163.285,542.724,163.32Z",
    transform: "translate(-542.724 -163.32)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(105.656 8.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M528.808,160.394a.766.766,0,0,0,.145.091l.428.236,1.584.85c1.337.716,3.181,1.712,5.2,2.838s3.84,2.169,5.154,2.929l1.556.9.426.24a.744.744,0,0,0,.153.075.773.773,0,0,0-.138-.1l-.412-.263c-.359-.226-.883-.547-1.533-.938-1.3-.782-3.111-1.84-5.135-2.967s-3.876-2.108-5.227-2.8c-.675-.347-1.223-.623-1.6-.809l-.441-.212A.758.758,0,0,0,528.808,160.394Z",
    transform: "translate(-528.808 -160.394)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051",
    transform: "translate(78.179 10.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M468.268,164.9a.474.474,0,0,0,.117.066l.347.164,1.284.589c1.083.5,2.575,1.194,4.2,2s3.089,1.569,4.142,2.13l1.246.663.341.177a.466.466,0,0,0,.124.053.5.5,0,0,0-.11-.078l-.328-.2c-.286-.172-.7-.412-1.225-.7-1.041-.583-2.494-1.361-4.127-2.169s-3.133-1.491-4.227-1.964c-.548-.237-.993-.423-1.3-.547l-.358-.139A.472.472,0,0,0,468.268,164.9Z",
    transform: "translate(-468.268 -164.895)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054",
    transform: "translate(82.133 10.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M476.98,164.122a6.592,6.592,0,0,0,.788.415c.491.246,1.165.595,1.892,1.009s1.37.818,1.832,1.115a6.471,6.471,0,0,0,.758.467,4.631,4.631,0,0,0-.7-.552c-.448-.32-1.086-.739-1.817-1.156s-1.416-.753-1.919-.976A4.665,4.665,0,0,0,476.98,164.122Z",
    transform: "translate(-476.98 -164.12)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057",
    transform: "translate(144.122 11.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M613.559,165.071c-.015.037,1.979.86,4.453,1.837s4.492,1.74,4.506,1.7-1.979-.86-4.453-1.837S613.574,165.034,613.559,165.071Z",
    transform: "translate(-613.559 -165.07)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "translate(146.706 10.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M619.252,163.291c-.014.037,1.707.718,3.842,1.521s3.88,1.423,3.894,1.385-1.706-.718-3.842-1.521S619.266,163.254,619.252,163.291Z",
    transform: "translate(-619.252 -163.289)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063",
    transform: "translate(29.435 30.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M360.87,208.621a1.359,1.359,0,0,0,.227-.011l.649-.059.468-.046c.172-.013.358-.018.559-.029.4-.015.856-.054,1.362-.042h.792c.275,0,.561.027.858.039.594.017,1.223.094,1.887.161a27.7,27.7,0,0,1,8.316,2.37c.6.292,1.175.559,1.689.857.259.145.515.275.75.419l.674.416c.436.256.8.529,1.135.753.164.115.321.217.459.319l.374.285.52.392a1.354,1.354,0,0,0,.188.129,1.338,1.338,0,0,0-.169-.152l-.5-.413-.367-.3c-.137-.1-.291-.211-.454-.329-.329-.231-.693-.511-1.127-.774l-.672-.426c-.234-.147-.49-.28-.748-.428-.513-.3-1.09-.576-1.691-.874a26.974,26.974,0,0,0-8.356-2.381c-.667-.064-1.3-.137-1.9-.149-.3-.01-.585-.032-.862-.031l-.8.008c-.507-.006-.964.04-1.366.064-.2.015-.388.023-.559.04l-.468.059-.646.086A1.291,1.291,0,0,0,360.87,208.621Z",
    transform: "translate(-360.87 -208.325)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(144.534 31.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M614.467,209.694a.856.856,0,0,0,.179.014l.514.012c.223,0,.5.007.812.03s.677.03,1.073.078l.622.062c.216.025.439.062.671.094.465.058.955.16,1.473.255a30.912,30.912,0,0,1,3.306.894A33.965,33.965,0,0,1,626.3,212.4c.955.447,1.8.883,2.49,1.279.351.189.657.381.93.542s.5.3.693.425l.437.271a.781.781,0,0,0,.158.086.86.86,0,0,0-.142-.11l-.422-.294c-.183-.128-.411-.28-.681-.447s-.572-.366-.921-.561c-.687-.408-1.53-.856-2.485-1.311A31.993,31.993,0,0,0,623.162,211a29.1,29.1,0,0,0-3.325-.886c-.521-.092-1.014-.191-1.482-.244-.234-.03-.458-.064-.676-.086l-.626-.054c-.4-.041-.76-.044-1.078-.057s-.591-.013-.815-.005l-.515.015A.829.829,0,0,0,614.467,209.694Z",
    transform: "translate(-614.467 -209.657)",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Towing-2",
    "data-name": "Towing",
    transform: "translate(15.606 344.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068",
    transform: "translate(99.284 74.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M463.525,320.756l-216.16,1.85v-8.378h216.16Z",
    transform: "translate(-247.365 -314.228)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069",
    transform: "translate(37.36 69.597)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 52.232,
    height: 22.026,
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(33.372 88.619)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 267.472,
    height: 15.415,
    transform: "translate(267.472 15.415) rotate(180)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071",
    transform: "translate(88.594 16.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    d: "M0,0H9.759a0,0,0,0,1,0,0V77.428a0,0,0,0,1,0,0h0A9.759,9.759,0,0,1,0,67.669V0A0,0,0,0,1,0,0Z",
    transform: "translate(9.759 77.428) rotate(180)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    transform: "translate(2.481 7.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M34.1,213.062c.02-3.169,1.231-5.28,3.475-8.478l29.038-36.625a4.232,4.232,0,0,1,3.01-1.241h46.3a4.27,4.27,0,0,1,4.27,4.27v56.517a8.985,8.985,0,0,1-9.17,8.983h0C71.321,230.8,64.3,261.4,64.3,261.4l-29.825-.519-.393-44.759Z",
    transform: "translate(-34.082 -166.718)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073",
    transform: "translate(3.39 11.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M36.084,213.083l3.41-.074,29.045-37.822-2.717-.478S46.435,198.84,38.271,209.521A36.03,36.03,0,0,0,36.084,213.083Z",
    transform: "translate(-36.084 -174.709)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(18.531 16.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M128.67,185.185l-34.525-.211a3.7,3.7,0,0,0-2.74,1.218l-21.3,28.146a2.936,2.936,0,0,0,2.282,4.788l56.259-.084a3.933,3.933,0,0,0,3.768-4.079v-25.7A3.936,3.936,0,0,0,128.67,185.185Z",
    transform: "translate(-69.443 -184.974)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(90.801 79.949)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 223.188,
    height: 12.016,
    transform: "translate(223.188 12.016) rotate(180)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(285.123 95.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M658.847,362.654h5.259a2.025,2.025,0,0,0,2.025-2.025h0a2.025,2.025,0,0,0-2.025-2.025h-5.259a2.025,2.025,0,0,0-2.025,2.025h0A2.025,2.025,0,0,0,658.847,362.654Z",
    transform: "translate(-656.822 -358.604)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    transform: "translate(9.691 104.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M54.426,387.39h81.485a4.46,4.46,0,0,0,4.46-4.46h0a4.46,4.46,0,0,0-4.46-4.46H54.426a4.46,4.46,0,0,0-4.46,4.46h0A4.46,4.46,0,0,0,54.426,387.39Z",
    transform: "translate(-49.966 -378.47)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079",
    transform: "translate(95.449 107.162)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 119.773,
    height: 4.102,
    transform: "translate(119.773 4.102) rotate(180)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(112.559 90.65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 61.686,
    height: 23.915,
    rx: 11.958,
    transform: "translate(61.686 23.915) rotate(180)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097",
    transform: "translate(103.934 29.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M277.663,245.5l-11.745-31.373-7.852.429-.454,46.114,212.7,1.541-.056-14.81Z",
    transform: "translate(-257.612 -214.123)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    transform: "translate(0.001 36.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M470.317,301.269l-212.681.43-.022-6.145,212.7.336Z",
    transform: "translate(-257.614 -295.553)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083",
    transform: "translate(133.611 0.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M559.863,296.046,552,301.638l7.571-.019,7.729-5.561Z",
    transform: "translate(-551.997 -296.046)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(116.971 0.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M523.2,296.108l-7.867,5.591,7.571-.019,7.729-5.561Z",
    transform: "translate(-515.334 -296.108)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085",
    transform: "translate(100.294 0.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M486.539,295.931l-7.95,5.726,7.572-.019,7.948-5.7Z",
    transform: "translate(-478.589 -295.931)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086",
    transform: "translate(83.635 0.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M449.93,295.873l-8.044,5.794,7.572-.019,7.859-5.763Z",
    transform: "translate(-441.886 -295.873)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087",
    transform: "translate(66.992 0.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M413.4,295.815l-8.182,5.861,7.556-.019,8.1-5.83Z",
    transform: "translate(-405.216 -295.815)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088",
    transform: "translate(50.318 0.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M376.6,295.757l-8.124,5.928,7.572-.019,8.072-5.9Z",
    transform: "translate(-368.479 -295.757)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089",
    transform: "translate(33.659 0.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M340.069,295.7l-8.294,6,7.572-.019,8.193-5.965Z",
    transform: "translate(-331.775 -295.699)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090",
    transform: "translate(17.001 0.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M303.489,295.642l-8.418,6.063,7.573-.019,8.144-6.033Z",
    transform: "translate(-295.071 -295.642)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(0.515 0.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M266.972,295.584l-8.225,6.135,7.571-.019,8.047-6.1Z",
    transform: "translate(-258.747 -295.584)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092",
    transform: "translate(148.902 0.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M593.578,295.971l-7.892,5.635,7.571-.019,7.839-5.546Z",
    transform: "translate(-585.686 -295.971)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093",
    transform: "translate(164.274 0.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M627.356,296.151l-7.8,5.545,7.412.008,7.822-5.534Z",
    transform: "translate(-619.556 -296.151)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094",
    transform: "translate(179.58 0.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M661.55,296.151l-8.27,5.531,7.571-.019,7.791-5.512Z",
    transform: "translate(-653.28 -296.151)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(194.701 0.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M694.4,296.309l-7.8,5.459,7.571-.019,7.664-5.422Z",
    transform: "translate(-686.596 -296.309)",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099",
    transform: "translate(9.779 11.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M125.513,239.388s-.008-.173-.012-.51-.007-.843-.012-1.5c0-1.322-.013-3.263-.022-5.76-.009-5.008-.022-12.245-.038-21.187,0-4.473-.009-9.371-.014-14.63q0-3.944-.006-8.15,0-2.1,0-4.262,0-1.08,0-2.175a10.711,10.711,0,0,0-.107-2.172,4.263,4.263,0,0,0-2.812-3.1,6.594,6.594,0,0,0-2.226-.213h-2.309l-9.473,0-19.921,0h-6.35a8.707,8.707,0,0,0-1.239.044,4.232,4.232,0,0,0-2.184,1,5.028,5.028,0,0,0-.8.916l-.743.992-1.477,1.973-2.919,3.9-11.129,14.85L56.53,206.32l-2.484,3.312a25.976,25.976,0,0,0-2.271,3.281,12.193,12.193,0,0,0-1.427,5.482q0,.931,0,1.845,0,3.662-.01,7.021c-.019,8.942-.034,16.179-.044,21.186-.01,2.5-.019,4.438-.024,5.76-.005.655-.01,1.156-.012,1.5s-.012.511-.012.511-.008-.173-.012-.511-.006-.843-.011-1.5c0-1.322-.012-3.262-.02-5.76-.007-5.007-.018-12.243-.03-21.184q0-3.354,0-7.02,0-.918-.009-1.853a12.649,12.649,0,0,1,.181-1.889,12.517,12.517,0,0,1,1.259-3.68,26.132,26.132,0,0,1,2.283-3.311l2.479-3.316,5.176-6.921,11.119-14.86,2.917-3.9,1.477-1.973.743-.992a5.219,5.219,0,0,1,.834-.949,4.468,4.468,0,0,1,2.305-1.053,8.967,8.967,0,0,1,1.272-.046h6.35l19.921,0,9.473,0h2.309a6.785,6.785,0,0,1,2.3.226A4.483,4.483,0,0,1,125.511,179c.042.184.065.373.089.56.007.187.025.379.021.561q0,.551,0,1.1,0,1.095,0,2.175,0,2.161,0,4.262,0,4.2-.006,8.15c0,5.259-.01,10.158-.014,14.63-.016,8.942-.029,16.179-.038,21.187-.01,2.5-.017,4.438-.022,5.76,0,.655-.009,1.156-.012,1.5S125.513,239.388,125.513,239.388Z",
    transform: "translate(-50.161 -175.502)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100",
    transform: "translate(32.516 30.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M103.985,237.759h0a3.728,3.728,0,0,1-3.728-3.729V220.712a3.728,3.728,0,0,1,3.728-3.729h0a3.729,3.729,0,0,1,3.729,3.729V234.03A3.729,3.729,0,0,1,103.985,237.759Z",
    transform: "translate(-100.257 -216.983)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101",
    transform: "translate(26.579 35.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M88.537,248.611H87.175V234.205a4.5,4.5,0,0,1,2.5-4.01c3.5-1.716,3.99-1.786,4.2-1.816l.192,1.348-.1-.674.1.674a24.034,24.034,0,0,0-3.793,1.691,3.124,3.124,0,0,0-1.736,2.788Z",
    transform: "translate(-87.175 -228.379)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102",
    transform: "translate(27.382 45.807)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 7.823,
    height: 1.362,
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103",
    transform: "translate(24.814 51.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M85.909,271.237h0a2.622,2.622,0,0,1-2.622-2.622V265.38a2.622,2.622,0,0,1,2.622-2.622h0a2.622,2.622,0,0,1,2.622,2.622v3.235A2.622,2.622,0,0,1,85.909,271.237Z",
    transform: "translate(-83.287 -262.758)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104",
    transform: "translate(51.556 5.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M161.192,163.672H142.208a2.531,2.531,0,0,1,2.531-2.531h13.922a2.531,2.531,0,0,1,2.531,2.531Z",
    transform: "translate(-142.208 -161.141)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105",
    transform: "translate(55.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M162.89,154.649H150.567a5.4,5.4,0,0,1,5.4-5.4h1.532a5.4,5.4,0,0,1,5.4,5.4Z",
    transform: "translate(-150.567 -149.254)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107",
    transform: "translate(49.359 23.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M158.812,200.433c.04.051-4.727,3.92-10.649,8.639s-10.757,8.506-10.8,8.455,4.727-3.919,10.65-8.64S158.772,200.382,158.812,200.433Z",
    transform: "translate(-137.366 -200.433)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109",
    transform: "translate(46.401 29.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M152.3,215.107c.041.051-4.727,3.92-10.649,8.639s-10.756,8.506-10.8,8.455,4.727-3.918,10.65-8.64S152.255,215.057,152.3,215.107Z",
    transform: "translate(-130.849 -215.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150",
    transform: "translate(43.451 85.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M170.256,360.678A22.953,22.953,0,1,1,147.3,337.725,22.953,22.953,0,0,1,170.256,360.678Z",
    transform: "translate(-124.35 -337.725)",
    fill: "#455a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125",
    transform: "translate(0 22.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M170.253,388.166c0,.02,0,.039,0,.059a22.953,22.953,0,0,1-45.906,0c0-.02,0-.039,0-.059Z",
    transform: "translate(-124.35 -388.166)",
    fill: "#455a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    transform: "translate(6.838 6.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M171.646,368.907a16.115,16.115,0,1,1-16.114-16.115A16.115,16.115,0,0,1,171.646,368.907Z",
    transform: "translate(-139.417 -352.792)",
    fill: "#fafafa"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141",
    transform: "translate(6.838 6.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M155.532,352.792a16.114,16.114,0,0,1,16.114,16.115H139.417A16.115,16.115,0,0,1,155.532,352.792Z",
    transform: "translate(-139.417 -352.792)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(13.137 13.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M172.927,376.485a9.816,9.816,0,1,1-9.816-9.816A9.816,9.816,0,0,1,172.927,376.485Z",
    transform: "translate(-153.294 -366.669)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(205.039 83.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 22.953,
    cy: 22.953,
    rx: 22.953,
    ry: 22.953,
    transform: "translate(0 45.642) rotate(-83.854)",
    fill: "#455a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    transform: "translate(2.325 25.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M531.4,388.036c0,.02,0,.039,0,.059a22.953,22.953,0,0,1-45.906,0c0-.02,0-.039,0-.059Z",
    transform: "translate(-485.496 -388.036)",
    fill: "#455a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174",
    transform: "translate(9.164 9.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M532.792,368.776a16.115,16.115,0,1,1-16.114-16.115A16.114,16.114,0,0,1,532.792,368.776Z",
    transform: "translate(-500.563 -352.661)",
    fill: "#fafafa"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    transform: "translate(9.164 9.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M516.678,352.661a16.115,16.115,0,0,1,16.114,16.115H500.563A16.115,16.115,0,0,1,516.678,352.661Z",
    transform: "translate(-500.563 -352.661)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(15.462 15.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M534.073,376.355a9.816,9.816,0,1,1-9.816-9.817A9.816,9.816,0,0,1,534.073,376.355Z",
    transform: "translate(-514.44 -366.538)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(88.62 71.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M433.255,326.135s-.2.008-.593.013l-1.741.015-6.694.035-24.62.084-81.226.19-94.444.129h-.067v-.067c.014-6.459.024-11.567.032-15.066.007-1.744.013-3.086.017-4q.006-.675.009-1.028c0-.231.009-.349.009-.349s.006.118.01.349,0,.578.009,1.028c0,.911.01,2.253.017,4,.007,3.5.018,8.608.031,15.066l-.067-.067,94.444-.231,81.226-.121,24.62-.01,6.694.01,1.741.009C433.054,326.127,433.255,326.135,433.255,326.135Z",
    transform: "translate(-223.87 -306.094)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    transform: "translate(0 92.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(0.078 0.118)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 37.282,
    height: 12.418,
    rx: 6.209,
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M32.553,365.611s-.081,0-.24,0a3.24,3.24,0,0,1-.7-.095,3.885,3.885,0,0,1-2.948-3.3,10.563,10.563,0,0,1-.036-1.122q0-.581,0-1.207,0-1.251-.009-2.67a3.992,3.992,0,0,1,1.006-2.8A3.951,3.951,0,0,1,32.61,353.1l3.571-.007,7.878-.011,18.052-.01a4,4,0,0,1,2.306.738,3.955,3.955,0,0,1,1.441,1.906,3.777,3.777,0,0,1,.226,1.174c.016.4,0,.775.008,1.161q0,1.151,0,2.284,0,.566,0,1.127A5.05,5.05,0,0,1,66,362.6a4.2,4.2,0,0,1-.4,1.063,4.388,4.388,0,0,1-.675.9A4,4,0,0,1,63,365.618a4.551,4.551,0,0,1-1.077.1H60.881l-14.744-.025-9.94-.037-2.7-.022-.7-.012c-.158,0-.24-.012-.24-.012s.081-.008.24-.012l.7-.012,2.7-.022,9.94-.038,14.744-.025h1.047a4.288,4.288,0,0,0,1.027-.1,3.782,3.782,0,0,0,1.807-1,4.177,4.177,0,0,0,.635-.848,3.972,3.972,0,0,0,.374-1,4.843,4.843,0,0,0,.088-1.086q0-.561,0-1.127,0-1.132,0-2.284a6.264,6.264,0,0,0-.221-2.256,3.719,3.719,0,0,0-1.356-1.792,3.76,3.76,0,0,0-2.169-.694L44.059,353.3l-7.878-.011-3.571-.007a3.779,3.779,0,0,0-2.863,1.247,3.836,3.836,0,0,0-.979,2.69q0,1.417-.009,2.67,0,.625,0,1.207a10.513,10.513,0,0,0,.025,1.109,3.785,3.785,0,0,0,.687,1.777,3.847,3.847,0,0,0,2.161,1.486A6.311,6.311,0,0,0,32.553,365.611Z",
    transform: "translate(-28.615 -353.075)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198",
    transform: "translate(22.818 97.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M80.9,367.845h4.871a2.005,2.005,0,0,0,2.006-2.006h0a2.006,2.006,0,0,0-2.006-2.006H80.9a2.006,2.006,0,0,0-2.006,2.006h0A2.006,2.006,0,0,0,80.9,367.845Z",
    transform: "translate(-78.89 -363.833)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199",
    transform: "translate(3.39 74.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M36.084,329.335h0V313.822h0a5.106,5.106,0,0,1,5.106,5.107v5.3A5.106,5.106,0,0,1,36.084,329.335Z",
    transform: "translate(-36.084 -313.822)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201",
    transform: "translate(36.747 31.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M111.906,233.017a2.86,2.86,0,0,1-.05-.593c-.013-.429-.03-.97-.049-1.616-.031-1.365-.058-3.252-.073-5.334-.005-1.038-.011-2.027-.016-2.935a4.869,4.869,0,0,0-.464-2.282,2.427,2.427,0,0,0-1.116-1.069,4.134,4.134,0,0,0-.56-.168c0-.008.054-.011.156-.01a1.611,1.611,0,0,1,.438.093,2.421,2.421,0,0,1,1.227,1.072,4.884,4.884,0,0,1,.537,2.359c.01.909.022,1.9.034,2.939.015,2.083.015,3.969,0,5.335-.01.646-.019,1.188-.026,1.617A2.863,2.863,0,0,1,111.906,233.017Z",
    transform: "translate(-109.578 -219.01)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203",
    transform: "translate(46.676 7.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M163.59,166.133c0,.065-7.194.118-16.066.118s-16.068-.053-16.068-.118,7.192-.118,16.068-.118S163.59,166.068,163.59,166.133Z",
    transform: "translate(-131.456 -166.015)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205",
    transform: "translate(56.369 1.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M158.827,151.73c-.01.039-.413-.072-1.075-.084a5.126,5.126,0,0,0-4.378,2.253c-.375.545-.52.938-.557.923a2.539,2.539,0,0,1,.417-1.013,4.851,4.851,0,0,1,4.526-2.329A2.531,2.531,0,0,1,158.827,151.73Z",
    transform: "translate(-152.812 -151.464)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    "data-name": "Group 1207",
    transform: "translate(66.962 56.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M186.437,276c0-.013.1-.01.271-.049a1.609,1.609,0,0,0,.69-.333,1.565,1.565,0,0,0,.557-1.037,1.528,1.528,0,0,0-.61-1.382,1.481,1.481,0,0,0-.847-.3l-1.042,0-2.307.011-5.287.01a1.48,1.48,0,0,0-.846,2.692,1.465,1.465,0,0,0,.534.234,2.785,2.785,0,0,0,.591.035l4.319.025,2.911.038.792.022a1.231,1.231,0,0,1,.276.024,1.209,1.209,0,0,1-.276.024l-.792.022-2.911.037-4.319.025a2.951,2.951,0,0,1-.638-.036,1.683,1.683,0,0,1-.616-.266,1.709,1.709,0,0,1,.975-3.114l5.287.01,2.307.01,1.049.01a1.657,1.657,0,0,1,.949,2.968,1.551,1.551,0,0,1-.739.307A.85.85,0,0,1,186.437,276Z",
    transform: "translate(-176.151 -272.696)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    "data-name": "Group 1214",
    transform: "translate(32.315 61.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    "data-name": "Group 1208",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 34.089,
    height: 10.521,
    rx: 5.261,
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1213",
    "data-name": "Group 1213",
    transform: "translate(4.432 3.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1210",
    "data-name": "Group 1210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    "data-name": "Group 1209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M133.768,293.423c0,.065-5.416.118-12.094.118s-12.1-.053-12.1-.118,5.415-.118,12.1-.118S133.768,293.358,133.768,293.423Z",
    transform: "translate(-109.578 -293.305)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    "data-name": "Group 1212",
    transform: "translate(4.07 2.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M136.351,298.616c0,.065-3.986.118-8.9.118s-8.9-.053-8.9-.118,3.985-.118,8.9-.118S136.351,298.551,136.351,298.616Z",
    transform: "translate(-118.545 -298.498)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216",
    transform: "translate(98.089 79.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M462.087,326.892s-.19.008-.561.011l-1.647.01-6.333.015-23.292-.034c-19.667-.065-46.836-.282-76.841-.581s-57.186-.542-76.852-.649l-23.29-.109-6.332-.03-1.647-.014c-.371,0-.561-.013-.561-.013s.19-.008.561-.011l1.647-.01,6.332-.015,23.29.035c19.667.064,46.838.282,76.853.58s57.172.542,76.839.65l23.291.109,6.333.029,1.647.014C461.9,326.883,462.087,326.892,462.087,326.892Z",
    transform: "translate(-244.732 -325.462)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(200.202 464.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846",
    transform: "translate(2.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M443.014,413.531a2.182,2.182,0,0,1,1.13,1.279,3.851,3.851,0,0,1,.15,1.733,6.792,6.792,0,0,1-1.455,3.159,4.6,4.6,0,0,1-1.23-3.007c-.1-1.167.422-3.339,1.4-3.165",
    transform: "translate(-441.596 -413.521)",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849",
    transform: "translate(5.144 5.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M446.708,428.41a1.86,1.86,0,0,1,.6-1.768,2.468,2.468,0,0,1,1.821-.569,1.037,1.037,0,0,1,.8.359.794.794,0,0,1,.012.806,1.611,1.611,0,0,1-.6.588,3.2,3.2,0,0,1-2.637.584",
    transform: "translate(-446.665 -426.065)",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(3.971 6.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M444.081,433.195a1.3,1.3,0,0,1,.034-.231l.114-.625a6.529,6.529,0,0,1,.645-2,3.991,3.991,0,0,1,1.432-1.522,2.688,2.688,0,0,1,.584-.258,1.537,1.537,0,0,1,.168-.043.176.176,0,0,1,.06-.009,4.261,4.261,0,0,0-.782.359,4.12,4.12,0,0,0-1.39,1.512,7.016,7.016,0,0,0-.659,1.968c-.058.261-.1.474-.14.62A1.3,1.3,0,0,1,444.081,433.195Z",
    transform: "translate(-444.08 -428.512)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857",
    transform: "translate(3.961 1.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M444.1,417.264a.5.5,0,0,1,.012.1c0,.075.01.171.017.29.013.252.028.616.043,1.067.029.9.052,2.147.046,3.523s-.04,2.622-.077,3.523c-.019.451-.036.815-.052,1.067-.008.119-.014.215-.02.29a.463.463,0,0,1-.013.1.481.481,0,0,1,0-.1c0-.075,0-.171,0-.29.006-.262.015-.624.026-1.067.022-.9.047-2.146.053-3.522s-.008-2.62-.022-3.521c-.007-.443-.013-.8-.017-1.067l0-.29A.479.479,0,0,1,444.1,417.264Z",
    transform: "translate(-444.057 -417.264)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860",
    transform: "translate(0 5.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M438.879,428.718a4.35,4.35,0,0,0-2.375-3.187.917.917,0,0,0-.99-.015.9.9,0,0,0-.075.986,3.717,3.717,0,0,0,3.418,2.308",
    transform: "translate(-435.331 -425.376)",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864",
    transform: "translate(1.326 6.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M438.253,428.069a1.145,1.145,0,0,1,.2.088,1.994,1.994,0,0,1,.227.121c.085.053.188.1.289.181a3.776,3.776,0,0,1,.331.249,4.36,4.36,0,0,1,.352.32,4.844,4.844,0,0,1,.669.86,4.714,4.714,0,0,1,.441,1,4.11,4.11,0,0,1,.111.462,3.568,3.568,0,0,1,.057.41,3.244,3.244,0,0,1,.015.341,2.026,2.026,0,0,1-.007.257,1.139,1.139,0,0,1-.025.218c-.019,0,.014-.313-.041-.811a3.867,3.867,0,0,0-.066-.4,4.23,4.23,0,0,0-.117-.453,4.9,4.9,0,0,0-.439-.976,5,5,0,0,0-.653-.849,4.473,4.473,0,0,0-.341-.321c-.109-.1-.221-.178-.32-.254C438.53,428.215,438.245,428.085,438.253,428.069Z",
    transform: "translate(-438.253 -428.069)",
    fill: "#263238"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowing);
export default __webpack_public_path__ + "static/media/towing.e9c7b266cd38ae6285d228592ec8f3a3.svg";
export { ForwardRef as ReactComponent };